import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'checkArray'
})
export class CheckArrayPipe implements PipeTransform {

  transform(array: any, key: any): any {
    let val = array.find(v => v.Index == key);
    return val? false : true;
  }

}
